import React, { forwardRef, useEffect, useRef, useState } from 'react';
import styles from './TableListEditableNew.module.scss';

interface InputCellEditorProps {
  value?: string | number | null;
  maxLength?: number;
  placeholder?: string;
  onValueChange?: (value: string) => void;
}

const InputCellEditor = forwardRef<any, InputCellEditorProps>((props, _ref) => {
  const [value, setValue] = useState(String(props.value ?? ''));
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const nextValue = event.target.value;
    if (props.maxLength && nextValue.length > props.maxLength) return;
    setValue(nextValue);
    props.onValueChange?.(nextValue);
  };

  return (
    <input
      ref={inputRef}
      className={styles.InputEditor}
      value={value}
      onChange={handleChange}
      placeholder={props.placeholder}
    />
  );
});

InputCellEditor.displayName = 'InputCellEditor';

export default InputCellEditor;
